import React, { FunctionComponent } from 'react'
import { generatePath, Route, Routes } from 'react-router'

import { getProduct, ManagementType, useConfig } from '../../../state/configuration'
import { AppPath } from '../../AppPath'
import { useProduct } from '../productContext'
import { RenewalAdditionalProfileRouter } from './RenewalAdditionalProfileRouter'
import { RenewalDisclosurePage } from './RenewalDisclosurePage'
import { RenewalPath } from './RenewalPath'

export const RenewalDisclosureRouter: FunctionComponent = () => {
  const { scheme } = useProduct()
  const {
    renewal: { sections },
  } = useConfig(getProduct(scheme.schemeCode))

  const routes = sections.map((it) => {
    const element = (() => {
      switch (it.type) {
        case ManagementType.ADDITIONAL_PROFILE:
          return <RenewalAdditionalProfileRouter config={it} />
        default:
          return <RenewalDisclosurePage config={it} />
      }
    })()

    return (
      <Route
        key={it.id}
        path={generatePath(RenewalPath.SECTION, { sectionId: it.id }) + AppPath.WILDCARD}
        element={element}
      />
    )
  })

  return <Routes>{routes}</Routes>
}
